<template>
  <el-dialog
    class="dialog-container"
    :title="title"
    :visible.sync="dialogVisible"
    width="550px"
    append-to-body
  >
    <div v-if="!importData.file" class="upload-box">
      <div style="margin-bottom: 10px; display: flex;justify-content: flex-end;">
        <el-button
          v-if="templateUrl"
          class="primary-btn"
          type="primary"
          @click="downModel"
          icon="el-icon-download"
        >
          下载模板
        </el-button>
      </div>
      <el-upload
        ref="uploadRef"
        action=""
        accept=".xls,.xlsx"
        drag
        :limit="1"
        :auto-upload="false"
        :show-file-list="false"
        :on-change="handleFileChange"
        :on-exceed="handleFileExceed"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip">
          支持文件类型：xls、xlsx
        </div>
      </el-upload>
    </div>
    <div class="upload-file" v-else>
      <img src="@/assets/img/excel.svg" />
      <div class="upload-progress">
        <div class="file-name">
          <div>
            {{ importData.file.name }}
            <span class="file-size">
              {{ formatBytes(importData.file.size) }}
            </span>
          </div>
          <div>
            <el-button
              v-if="!uploading && total === null"
              type="text"
              style="padding:0"
              @click="resetUploadData"
              >删除</el-button
            >
          </div>
        </div>
        <el-progress
          v-if="uploading"
          class="progress-bar"
          :percentage="uploadPercentage"
          :stroke-width="11"
          define-back-color="#DBDEE0"
          color="#1AD368"
        ></el-progress>
        <div class="complete" v-else>
          <span v-if="total === 0 || total" class="complete-success">
            导入成功，共{{ total }}条数据
          </span>
          <span v-else class="complete-error">
            <i
              class="el-icon-warning-outline"
              style="margin-right:10px"
            />导入失败
          </span>
        </div>
      </div>
    </div>
    <div
      slot="footer"
      class="text-center"
      v-if="!importData.file || !uploading"
    >
      <el-button
        v-if="!(total === 0 || total)"
        type="primary"
        @click="handleFileChange()"
        >重新导入</el-button
      >
      <el-button type="primary" @click="dialogVisible = false">返回</el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from "axios"; // 引入axios

export default {
  components: {},
  props: {
    carTypeList: {
      type: Array,
      default: () => {}
    },
    uploadUrl: {
      type: String,
      default: ""
    },
    templateUrl: {
      type: String,
      default: ""
    },
    params: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      title: "",
      dialogVisible: false,
      importData: {
        file: ""
      },
      uploadPercentage: 0, // 导入进度
      uploading: false, // 导入状态
      total: 0 // 导入条数
    };
  },
  mounted() {},
  methods: {
    // 初始化
    async init(title) {
      this.title = title;
      this.resetUploadData();
      this.dialogVisible = true;
    },
    // 下载模板
    downModel() {
      window.open(this.templateUrl, "_blank");
    },
    // 重置导入数据
    resetUploadData() {
      this.importData = {
        file: ""
      };
      this.total = 0;
    },
    // 导入文件
    handleFileChange(file = {}) {
      this.uploadPercentage = 0;
      this.importData.file = file.raw || this.importData.file;
      const formData = new FormData();
      formData.append("file", this.importData.file);
      // if (this.params) {
      //   for (const key in this.params) {
      //     formData.append(key, this.params[key]);
      //   }
      // }
      this.uploading = true;
      // console.log(formData,'xxx',this.params)
      // return
      axios({
        method: "post",
        url: this.uploadUrl,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          satoken: sessionStorage.getItem("token")
        },
        onUploadProgress: progressEvent => {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }
      })
        .then(res => {
          if (res.data.status == 0) {
            if (typeof res.data.data === "number") {
              this.total = res.data.data;
            }
            if (Array.isArray(res.data.data)) {
              this.total = res.data.data.length;
            }
            if (res.data.data && typeof res.data.data.totalCount === "number") {
              this.total = res.data.data.totalCount;
            }
            this.$emit("success", res.data.data);
          } else {
            this.total = null;
            this.$DonMessage.error(res.data.message);
          }
          this.uploading = false;
        })
        .catch(error => {
          this.total = null;
          this.uploading = false;
        });
    },
    // 文件超出个数
    handleFileExceed() {
      this.$DonMessage.warning("只能导入一个文件");
    },
    // 文件大小字节转换
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return "0 Bytes";
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + "" + sizes[i];
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-container {
  ::v-deep .el-upload {
    width: 100%;
  }
  ::v-deep .el-upload-dragger {
    width: 100%;
  }
  .upload-file {
    display: flex;
    align-items: center;
    background: #efefef;
    padding: 9px 16px 18px 16px;
    .upload-progress {
      flex: 1;
      margin-left: 18px;
      .file-name {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #000000;
        font-size: 14px;
      }
      .file-size {
        color: #bebebe;
        margin-left: 14px;
      }
      .progress-bar {
        width: 250px;
        margin-top: 12px;
      }
      ::v-deep .el-progress__text {
        font-size: 14px !important;
      }
      .complete {
        margin-top: 4px;
        .complete-success {
          color: #0ec98e;
        }
        .complete-error {
          color: #ff0000;
        }
      }
    }
  }
}
</style>
